import PropTypes from "prop-types";
import { FiRefreshCw } from "react-icons/fi";

export default function ListFetchErrorBanner({ message, onRetry, loading = false, retryAriaLabel = "Refresh" }) {
  return (
    <div
      className="mb-4 flex items-center justify-between gap-3 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-800"
      role="alert"
    >
      <span className="min-w-0 flex-1">{message}</span>
      <button
        type="button"
        onClick={onRetry}
        disabled={loading}
        aria-label={retryAriaLabel}
        className="inline-flex shrink-0 items-center justify-center rounded-lg border border-red-300 bg-white p-2 text-red-800 transition hover:bg-red-100 disabled:cursor-not-allowed disabled:opacity-50"
      >
        <FiRefreshCw className={`h-4 w-4 ${loading ? "animate-spin" : ""}`} aria-hidden />
      </button>
    </div>
  );
}

ListFetchErrorBanner.propTypes = {
  message: PropTypes.string.isRequired,
  onRetry: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  retryAriaLabel: PropTypes.string,
};
